module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/02_Introduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Part01"
    }
  }, [_vm._v("Kwaidan")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter01"
    }
  }, [_vm._v("The Story of Mimi-Nashi-Hoichi")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oshidori")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of O-Tei")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ubazakura")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diplomacy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Of a Mirror and a Bell")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jikininki")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mujina")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rokuro-Kubi")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dead Secret")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yuki-Onna")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Aoyagi")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jiu-Roku-Zakura")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream of Akinosuke")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riki-Baka")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hi-Mawari")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horai")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Insect Studies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter18#lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterflies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mosquitoes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ants")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0